import { SoulMatrixContent } from './SoulMatrixContent';

export default SoulMatrixContent;
